// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InnerInstruction
 */
export interface InnerInstruction {
    /**
     * 
     * @type {string}
     * @memberof InnerInstruction
     */
    programId: string;
    /**
     * 
     * @type {string}
     * @memberof InnerInstruction
     */
    data: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InnerInstruction
     */
    accounts: Array<string>;
}

/**
 * Check if a given object implements the InnerInstruction interface.
 */
export function instanceOfInnerInstruction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programId" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "accounts" in value;

    return isInstance;
}

export function InnerInstructionFromJSON(json: any): InnerInstruction {
    return InnerInstructionFromJSONTyped(json, false);
}

export function InnerInstructionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InnerInstruction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programId': json['programId'],
        'data': json['data'],
        'accounts': json['accounts'],
    };
}

export function InnerInstructionToJSON(value?: InnerInstruction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programId': value.programId,
        'data': value.data,
        'accounts': value.accounts,
    };
}

